import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pages/BlogsIndexPage.tsx");
